<template>
  <div
    v-on:click="toggle"
    :class="[color, { 'opacity-50 cursor-not-allowed': disabled }]"
    class="rounded-full papsi-switch"
  >
    <div
      :class="{ 'papsi-selected': status }"
      class="switch-thumb bg-white"
    ></div>
  </div>
</template>

<script>
export default {
  name: "v-switch-control",
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      status: false,
      color: "bg-grey-light",
    };
  },
  mounted() {
    this.status = this.checked;
    this.color = this.status ? "bg-green" : "bg-grey-light";
  },
  methods: {
    toggle() {
      if (this.disabled) return;

      if (this.type === "EFT") {
        if (this.status) {
          this.status = false;
          this.color = "bg-grey-light";
          this.$emit("toggle", false);
        } else {
          this.$emit("toggle", true);
        }
      } else {
        this.status = !this.status;
        this.color = this.status ? "bg-green" : "bg-grey-light";
        this.$emit("toggle", this.status);
      }
    },
  },
  watch: {
    checked(n) {
      this.status = n;
      this.color = this.status ? "bg-green" : "bg-grey-light";
    },
  },
};
</script>

<style scoped>
.papsi-switch {
  width: 48px;
  display: flex;
  align-items: center;
  padding: 2px;
  border-radius: 9999px;
  cursor: pointer;
  overflow: hidden;
  transition: background-color 0.25s ease;
}

.switch-thumb {
  width: 20px; 
  height: 20px;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: margin-left 0.25s ease;
}
.papsi-selected {
  margin-left: 24px;
}


.bg-grey-light {
  background-color: #d1d5db;
}

.bg-green {
  background-color: #016B00;
}
</style>
